<template>
  <v-data-iterator
    :items="orders.data"
    :page.sync="c_page"
    :items-per-page.sync="c_size"
    :server-items-length="orders.meta.pagination.total"
    :footer-props="{ itemsPerPageOptions }"
  >
    <template v-slot:default="slot">
      <im-order-card v-for="(order, index) in slot.items"
        :order="order"
        :key="index"
        @edit="$emit('edit', order)"
      />
    </template>
  </v-data-iterator>
</template>

<script>

  export default {

    components: {
      'im-order-card': () => import('@/components/Order/OrderCard')
    },

    props: {
      orders: null,
    },

    data: () => ({
      pagination: {
        page: 1,
        size: 10,
      },
      itemsPerPageOptions: [10, 15, 30, 50]
    }),

    computed: {
      c_page: {
        get() {
          return this.pagination.page;
        },
        set(val) {
          this.$emit('update:pagination', {
            page: val,
            size: this.pagination.size,
          })
        }
      },
      c_size: {
        get() {
          return this.pagination.size;
        },
        set(val) {
          this.$emit('update:pagination', {
            page: this.pagination.page,
            size: val
          })
        }
      }
    }

  }

</script>